// import Event1 from "../../../Assets/Images/home/upcom/Munchkin.png";
// import Event2 from "../../../Assets/Images/home/upcom/New St. Pats  Winter  (3).png";
import Event1 from "../../../Assets/Images/home/upcom/SPRING-Munchkin-Monday-2026v5.png";
import Event11 from "../../../Assets/Images/SummerCampDetails/summer_camp_flyerv2.png";
import Event2 from "../../../Assets/Images/home/upcom/New St.Pats Spring.png";
import Event3 from "../../../Assets/Images/home/upcom/ONYXX MAY.png";
// import Event4 from "../../../Assets/Images/home/upcom/spring-clinic-2026.png";
import Event5 from "../../../Assets/Images/home/upcom/SSxSI-Spring-v2.png";
import Event6 from "../../../Assets/Images/home/upcom/Mini_ballers_Summer_camp-2026.png";
import "./upcomingevents.css";
import { useNavigate } from "react-router-dom";

const UpcomingEvents = () => {
  const navigate = useNavigate();
  const handleRedirect = (url) => {
    window.location.href = url;
  };

  return (
    <div className="upcomingEvent">
      <div className="container">
        <h2>Upcoming Events</h2>
        <div className="ue-listing">

          <div className="ue-card-item">
            <img
              src={Event11}
              alt="EventsImage"
              onClick={() =>
                navigate("/basketball-summer-camps-details")
              }
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="ue-card-item">
            <img
              src={Event1}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://events.shootinschool.com/ss-munchkin-mondays-sessions-2026",
                )
              }
              style={{ cursor: "pointer" }}
            />
          </div>

          <div className="ue-card-item">
            <img
              src={Event2}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://events.shootinschool.com/spring-saturday-sessions-10-week-program-st-patricks-2026",
                )
              }
            />
          </div>

          {/* <div className="ue-card-item">
            <img
              src={Event3}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://events.shootinschool.com/point-guard-onyxx-clinic-2026",
                )
              }
              style={{ cursor: "pointer" }}
            />
          </div> */}
          {/* <div className="ue-card-item">
            <img
              src={Event4}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://linktr.ee/ShootinSchool?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnmUVW1IogsB9Nv3G2lLs4-nc64Ik2oPPLM8ffNN5DpEbSt7yFYqQRhcOSFZA_aem_jBuS8as02ndo39-_VGrqUw",
                )
              }
              style={{ cursor: "pointer" }}
            />
          </div> */}
          {/* <div className="ue-card-item">
            <img
              src={Event5}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://events.shootinschool.com/si-finest-spring-tune-up-2026",
                )
              }
              style={{ cursor: "pointer" }}
            />
          </div> */}
          <div className="ue-card-item">
            <img
              src={Event6}
              alt="EventsImage"
              onClick={() =>
                handleRedirect(
                  "https://events.shootinschool.com/mini-ballers-ss-2026-page",
                )
              }
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpcomingEvents;
